// Aurora Innovation, Inc. Proprietary and Confidential. Copyright 2026.
import { linkColors } from './linkColors';
export var Link = function(mode) {
    var c = linkColors(mode);
    var override = {
        MuiLink: {
            defaultProps: {
                // MUI's own underline='hover' already produces textDecoration: 'none' by
                // default and 'underline' on :hover — let it own that behavior instead of
                // re-implementing it unconditionally in styleOverrides.root below, which
                // used to force the same look regardless of an explicit underline prop
                // (breaking underline="always"/"none" callers).
                underline: 'hover'
            },
            styleOverrides: {
                root: {
                    // Deliberately free of font styling: root wins over the typography MUI
                    // resolves from the variant prop, so a ramp here makes that prop inert —
                    // including its 'inherit' default, which has to keep inheriting the
                    // surrounding text's font.
                    cursor: 'pointer',
                    '&.Mui-disabled, &[aria-disabled="true"]': {
                        color: c.disabled.text,
                        textDecoration: 'none',
                        pointerEvents: 'none'
                    }
                }
            },
            variants: [
                {
                    // Body1 and Body2 are the two sizes the design defines for a link, both at
                    // medium weight; size and line height come from the typography variant.
                    props: {
                        variant: 'body1'
                    },
                    style: {
                        fontWeight: 500
                    }
                },
                {
                    props: {
                        variant: 'body2'
                    },
                    style: {
                        fontWeight: 500
                    }
                },
                {
                    // Only the default color='primary' gets the link brand color. Putting
                    // this in styleOverrides.root instead would unconditionally win over
                    // an explicit color="secondary"/"error"/etc, making that prop inert.
                    props: {
                        color: 'primary'
                    },
                    style: {
                        color: c.default.text
                    }
                }
            ]
        }
    };
    return override;
};

//# sourceMappingURL=Link.js.map